import React from 'react'
import { Link } from "react-router-dom"
import { Facebook, Instagram, Twitter, MapPin, Phone, Mail, GitHub, Globe } from "react-feather"
import { useGlobalData } from '../context/globalContext';

export default function Footer() {
	const iconMap = {
	Facebook: Facebook,
	Instagram: Instagram,
	Twitter: Twitter,
	Github: GitHub,
	Website: Globe, // default
	};
	const  websiteDetails  = useGlobalData();
	const webDetails = websiteDetails.websiteDetails

	 if (!webDetails?.social_med) return [];

	const socialMedia =  webDetails?.social_med.split(";").map((link) => {
	const [name, url] = link.split("=");
		return {
			name: name.trim(),
			href: url.startsWith("http") ? url.trim() : `https://${url.trim()}`,
			};
		});
	return (
		<footer id="contactus" className="grid grid-cols-1 md:(grid-cols-3) border-t border-gray-300 bg-gray-200 px-4">
			<div className="m-4 sm:m-6 flex-1">
				<div className="flex items-center mb-3">
								<h2 className="text-4xl text-center md:text">
								{webDetails?.brand_name}
								</h2>
								<img
								src={webDetails?.brand_logo}
								alt="Logo"
								className="h-16 w-auto"
								/>
							</div>
				{/* <h2 className="text-4xl text-center md:text-left mb-4">{webDetails?.brand_name}</h2> */}
				<p className="text-justify text-gray-700">{webDetails?.tag_line}</p>
				<ul className="flex mt-6 justify-center md:justify-start space-x-4">
				{socialMedia?.map(({ name, href }) => {
					const IconComponent = iconMap[name] || iconMap.Website; // default icon
					return (
					<li key={name}>
						<a href={href} target="_blank" rel="noopener noreferrer">
						<IconComponent />
						</a>
					</li>
					);
				})}
					{/* <li>
						<Link to="#"><Facebook /></Link>
					</li>				
					<li>
						<Link to="#"><Instagram /></Link>
					</li>				
					<li>
						<Link to="#"><Twitter /></Link>
					</li>
					<li>
						<a href="https://github.com/nimone/Fashion-Store"><GitHub /></a>
					</li>
					<li>
						<a href="https://nimo.pages.dev"><Globe /></a>
					</li> */}
				</ul>
			</div>			
			<div className="m-4 sm:m-6">
				<h2 className="text-xl text-center md:text-left font-medium mb-4">Useful Links</h2>
				<ul className="flex flex-col flex-wrap h-36 space-y-1 text-gray-600">
					<li>
						<Link to="/">Home</Link>
					</li>
					<li>
						<Link to="/cart">Cart</Link>
					</li>
					{/* <li>
						<Link to="/products?category=men">Men Fashion</Link>
					</li>
					<li>
						<Link to="/products?category=women">Women Fashion</Link>
					</li> */}
					<li>
						<Link to="/orders">Track Order</Link>
					</li>
					<li>
						<Link to="/account">My Account</Link>
					</li>							
					{/* <li>
						<Link to="/wishlist">Wishlist</Link>
					</li>					 */}
					<li>
						<Link to="/terms">Terms</Link>
					</li>
				</ul>
			</div>
			<div className="relative">			
			<div className="m-4 sm:m-6">
				<h2 className="text-xl text-center md:text-left font-medium mb-4">Contact</h2>
				<ul className="space-y-3 text-gray-700">
					{webDetails?.address ? 	<li className="flex items-center">
						<MapPin className="w-5 h-5 mr-2" />
						<span>{webDetails?.address}</span>
					</li>:<></>}
					{/* <li className="flex items-center">
						<MapPin className="w-5 h-5 mr-2" />
						<span>{webDetails?.address}</span>
					</li>					 */}
					<li className="flex items-center">
						<Phone className="w-5 h-5 mr-2" />
						 <a
							href={`https://wa.me/${webDetails?.mobile}`}
							target="_blank"
							rel="noreferrer"
							// className="hover:underline"
						>
							{webDetails?.mobile}
						</a>
						{/* <span>{webDetails?.mobile}</span> */}
					</li>					
					<li className="flex items-center">
						<Mail className="w-5 h-5 mr-2" />
						<a href={`mailto:${webDetails?.email}`} target="_blank">
							{webDetails?.email}
						</a>
					</li>
					{/* <li className="flex items-center">
						<GitHub className="w-5 h-5 mr-2" />
						<a href="https://github.com/nimone/Fashion-Store" target="_blank">
							/Fashion-Store
						</a>
						<span className='mx-1'>built by</span>
						<a href="https://nimo.pages.dev" target="_blank" className='border-b-2 border-green-500'>
							nimo
						</a>
					</li> */}
				</ul>
				{/* <div className="mt-6">
					<img className="mx-auto md:mx-0" src="https://i.ibb.co/Qfvn4z6/payment.png" alt="payment providers" />
				</div> */}
			</div>
			<div className="absolute bottom-2 right-4 text-xs text-gray-700">
		         Powered By AccountsDeck
	         </div>
			 </div>
		</footer>
	)
}